import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import { MatDialogModule } from '@angular/material/dialog';
import {HttpClientModule, HTTP_INTERCEPTORS} from "@angular/common/http";
import {InterceptorInterceptor} from "@security/interceptor.interceptor";
import { NgxMaskModule } from 'ngx-mask'
import {MAT_DATE_FORMATS, MAT_DATE_LOCALE} from "@angular/material/core";
import {MY_DATE_FORMATS} from "@app/constans/constants";
import {InterceptorGuard} from "@security/interceptor.guard";
@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    MatDialogModule,
    HttpClientModule,
    NgxMaskModule.forRoot()
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: InterceptorInterceptor, multi: true },
    { provide: MAT_DATE_LOCALE, useValue: 'es' }, // Idioma
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
    InterceptorGuard
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
